import { HorizontalRule } from 'components/Layout';
import { FC } from 'react';

const HorizontalRuleDesktop: FC = () => <HorizontalRule role="separator" display={['none', 'block']} bg="greys.alto" />;

export default HorizontalRuleDesktop;
